import React from 'react';
import { Box, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { useTranslation } from 'react-i18next';
import { WalkIcon, CaloryIcon, TimeIcon } from '../../assets/images/activityIcons';
import DonutChart from '../charts/donutChart';
import { EXERCISE_TARGETS } from '../../constants';
import { calculatePercentage } from '../../utils/base';

const ExerciseSummary = ({
    totalSteps = 0,
    calories = 0,
    totalTime = 0,
    sx = {}
}) => {
    const theme = useTheme();
    const { t } = useTranslation();

    return (
        <Box
            sx={{
                display: 'flex',
                gap: '20px',
                alignItems: 'center',
                width: '100%',
                ...sx
            }}
        >
            <Box
                sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    gap: '10px',
                    flex: 1,
                }}
            >
                {/* Steps */}
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                    <WalkIcon />
                    <Typography variant="body1">
                        {totalSteps?.toLocaleString()} / {EXERCISE_TARGETS.STEPS.toLocaleString()}{t('didim')}
                    </Typography>
                </Box>

                {/* Calories */}
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                    <CaloryIcon />
                    <Typography variant="body1">
                        {calories} / {EXERCISE_TARGETS.CALORIES.toLocaleString()}kcal
                    </Typography>
                </Box>

                {/* Time */}
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                    <TimeIcon />
                    <Typography variant="body1">
                        {totalTime} / {EXERCISE_TARGETS.ACTIVITY_TIME.toLocaleString()}{t('min')}
                    </Typography>
                </Box>
            </Box>

            {/* Donut Chart */}
            <Box sx={{ width: '100px', height: '100px' }}>
                <DonutChart
                    data={[
                        {
                            label: t('didim'),
                            value: calculatePercentage(
                                totalSteps,
                                EXERCISE_TARGETS.STEPS
                            ),
                            color: theme.palette.figma.steps,
                            radius: 45,
                            strokeWidth: 10,
                        },
                        {
                            label: t('calories'),
                            value: calculatePercentage(
                                calories,
                                EXERCISE_TARGETS.CALORIES
                            ),
                            color: theme.palette.figma.calorieRed,
                            radius: 35,
                            strokeWidth: 10,
                        },
                        {
                            label: t('time'),
                            value: calculatePercentage(
                                totalTime,
                                EXERCISE_TARGETS.ACTIVITY_TIME
                            ),
                            color: theme.palette.figma.time,
                            radius: 25,
                            strokeWidth: 10,
                        },
                    ]}
                    size={100}
                    centerRadius={60}
                />
            </Box>
        </Box>
    );
};

export default ExerciseSummary;
